import { useState } from "react";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import LoginPage from "./Components/Login/LoginPage";
import DashboardLayout from "./Components/DashnoardLayout";

import DealerWiseSale from "./Components/PointOfSale/DealerWiseSale";
import BrandWiseSale from "./Components/PointOfSale/BrandWiseSale";
import SaleRegister from "./Components/PointOfSale/SaleRegister";
import ProductWiseSale from "./Components/PointOfSale/ProductWiseSale";
import SalesManWiseSale from "./Components/PointOfSale/SalesManWiseSale";
import DateWiseSale from "./Components/PointOfSale/DateWiseSale";
import CommodityWiseSale from "./Components/PointOfSale/CommodityWiseSale";
import TaxWiseSale from "./Components/PointOfSale/TaxWiseSale";
import HSNWiseSale from "./Components/PointOfSale/HSNWiseSale";
import GroupWiseSale from "./Components/PointOfSale/GroupWiseSale";

import OutstandingCustomers from "./Components/Accounts/OutstandingCustomers";
import OutstandingDealers from "./Components/Accounts/OutstandingDealers";
import CashBook from "./Components/Accounts/CashBook";
import BankStatement from "./Components/Accounts/BankStatement";
import RecieptRegister from "./Components/Accounts/RecieptRegister";
import PaymentReciept from "./Components/Accounts/PaymentRegister";
import PurshaseRegister from "./Components/Accounts/PurchaseRegister";
import JournalRegister from "./Components/Accounts/JournalRegister";
import SalesMenWiseCommission from "./Components/Accounts/SalesMenWiseCommission";
import CommodityWisePurchase from "./Components/Purchase/CommodityWisePurchase";
import ProductWisePurchase from "./Components/Purchase/ProductWisePurchase";
import DealerWisePurchase from "./Components/Purchase/DealerWisePurchse";
import HSNWisePurchase from "./Components/Purchase/HSNWisePurchase";
import BrandWisePurchase from "./Components/Purchase/BrandWisePurchase";
import TaxWisePurchase from "./Components/Purchase/TaxWisePurchase";
import TotalDues from "./Components/CRM/TotalDues";
import TodayAnniversaries from "./Components/CRM/TodayAnniversaries";
import TodayBirthDays from "./Components/CRM/TodayBirthDays";
import DayGlance from "./Components/PointOfSale/DayGlance";
import Graphs from "./Components/Graphs/Graphs";
import BarCodeCheck from "./Components/BarCodeCheck/BarCodeCheck";
import SalesInvoice from "./Components/PointOfSale/SalesInvoice/SalesInvoice";
import SalesInvoiceReturn from "./Components/PointOfSale/SaleReturn/SalesInvoiceReturn";
import ExchangeBill from "./Components/PointOfSale/ExchangeBill/ExchangeBill";
import ReturnRegister from "./Components/PointOfSale/ReturnRegister";
import AuthGuard from "./Components/AuthGuard";
import DashboardComponent from "./Components/Pages/Dashboard/Dashboard";
import TopTenInvoices from "./Components/Pages/TopTen/TopTenInvoices";
import TopTenBrands from "./Components/Pages/TopTen/TopTenBrands";
import TopTenPrices from "./Components/Pages/TopTen/TopTenPrices";
import TopTenSalesMan from "./Components/Pages/TopTen/TopTenSalesMan";
import TopTenProducts from "./Components/Pages/TopTen/TopTenProducts";
import PurchaseTypeWiseStock from "./Components/Pages/Inventory/PurchaseTypeWiseStock";
import ProductWiseStock from "./Components/Pages/Inventory/ProductWiseStock";
import HSNWiseStock from "./Components/Pages/Inventory/HSNWiseStock";
import BrandWiseStock from "./Components/Pages/Inventory/BrandWiseStock";
import DealerWiseStock from "./Components/Pages/Inventory/DealerWiseStock";
import GropuWiseStock from "./Components/Pages/Inventory/GroupWiseStock";
import StockPoint from "./Components/Pages/Inventory/StockPoint";
import ExcelUploadPurchase from "./Components/Purchase/ExcelUploadPurchase";
import MailBookRegister from "./Components/CRM/MailBookRegister";
import UserAccounts from "./Components/Utilities/UserAccounts";
import UserAccountManager from "./Components/Utilities/UserAccountManager";
import FirmConfiguration from "./Components/Utilities/FirmConfiguration";
import { UploadImage } from "./Components/Utilities/UploadImage";
import WhatsAppTemplates from "./Components/Utilities/WhatsappSMSTemplates";
import CounterConfigMaster from "./Components/Utilities/CounterConfig";
import AreaMaster from "./Components/Masters/AreaMaster";
import StateMaster from "./Components/Masters/StateMaster";
import PurchaseTypeMaster from "./Components/Masters/PurchaseTypeMaster";

import PurchaseInvoice from "./Components/Purchase/Purchaseinvoice";
import BrandMaster from "./Components/Masters/Brandmaster";
import ItemCategoryMaster from "./Components/Masters/Itemcategorymaster";
import ItemMaster from "./Components/Masters/Itemmaster";
import SizeMaster from "./Components/Masters/Sizemaster";
import ColourMaster from "./Components/Masters/Colourmaster";
import FittingMaster from "./Components/Masters/Fittingmaster";
import SleevesMaster from "./Components/Masters/Sleevesmaster";
import CodeMaster from "./Components/Masters/CodeMaster";

function App() {
  const tenantName = localStorage.getItem("tenantName");
  const [isAunthenticated, setIsAuthenticated] = useState(tenantName);
  const handleLogin = (responseData) => {
    setIsAuthenticated(responseData);
  };
  return (
    <Router>
      <Routes>
        <Route
          path="/"
          element={<LoginPage onLogin={handleLogin}></LoginPage>}
        ></Route>
        <Route element={<AuthGuard />}>
          <Route
            path="*"
            element={
              isAunthenticated ? (
                <DashboardLayout>
                  <Routes>
                    <Route path="/dashboard" element={<DashboardComponent />} />
                    {/*Top Ten Invoices*/}
                    <Route
                      path="/top-ten-invoices"
                      element={<TopTenInvoices />}
                    />
                    <Route path="/top-ten-brands" element={<TopTenBrands />} />
                    <Route path="/top-ten-prices" element={<TopTenPrices />} />
                    <Route
                      path="/top-ten-salesman"
                      element={<TopTenSalesMan />}
                    />
                    <Route
                      path="/top-ten-products"
                      element={<TopTenProducts />}
                    />
                    {/*Point of Sale */}
                    <Route path="/sale-invoice" element={<SalesInvoice />} />
                    <Route
                      path="/sale-return"
                      element={<SalesInvoiceReturn />}
                    />
                    <Route path="/exchange-bill" element={<ExchangeBill />} />
                    <Route path="/sale-register" element={<SaleRegister />} />
                    <Route
                      path="/return-register"
                      element={<ReturnRegister />}
                    />
                    <Route path="/day-glance" element={<DayGlance />} />
                    <Route
                      path="/product-wise-sale"
                      element={<ProductWiseSale />}
                    />
                    <Route
                      path="/brand-wise-sale"
                      element={<BrandWiseSale />}
                    />
                    <Route
                      path="/dealer-wise-sale"
                      element={<DealerWiseSale />}
                    />
                    <Route
                      path="/salesman-wise-sale"
                      element={<SalesManWiseSale />}
                    />
                    <Route path="/date-wise-sale" element={<DateWiseSale />} />
                    <Route
                      path="/commodity-wise-sale"
                      element={<CommodityWiseSale />}
                    />
                    <Route path="/tax-wise-sale" element={<TaxWiseSale />} />
                    <Route
                      path="/tax-wise-sale"
                      element={<CommodityWiseSale />}
                    />
                    <Route path="/hsn-wise-sale" element={<HSNWiseSale />} />
                    <Route
                      path="/group-wise-sale"
                      element={<GroupWiseSale />}
                    />
                    {/*Inventory */}
                    <Route path="/stock-point" element={<StockPoint />} />
                    <Route
                      path="/purchase-type-wise-stock"
                      element={<PurchaseTypeWiseStock />}
                    />
                    <Route
                      path="/product-wise-stock"
                      element={<ProductWiseStock />}
                    />
                    <Route path="/hsn-wise-stock" element={<HSNWiseStock />} />
                    <Route
                      path="/brand-wise-stock"
                      element={<BrandWiseStock />}
                    />
                    <Route
                      path="/dealer-wise-stock"
                      element={<DealerWiseStock />}
                    />
                    <Route
                      path="/group-wise-stock"
                      element={<GropuWiseStock />}
                    />
                    {/*Accounts */}
                    <Route
                      path="/outstanding-customers"
                      element={<OutstandingCustomers />}
                    />
                    <Route
                      path="/outstanding-dealers"
                      element={<OutstandingDealers />}
                    />
                    <Route path="/cash-book" element={<CashBook />} />
                    <Route path="/bank-statement" element={<BankStatement />} />
                    <Route
                      path="/receipt-register"
                      element={<RecieptRegister />}
                    />
                    <Route
                      path="/payment-register"
                      element={<PaymentReciept />}
                    />
                    <Route
                      path="/purchase-register"
                      element={<PurshaseRegister />}
                    />
                    <Route
                      path="/journal-register"
                      element={<JournalRegister />}
                    />
                    <Route
                      path="/salesmen-wise-commission"
                      element={<SalesMenWiseCommission />}
                    />
                    {/** Purchase */}
                    <Route
                      path="/purchase-invoice"
                      element={<PurchaseInvoice />}
                    />
                    <Route
                      path="/commodity-wise-purchase"
                      element={<CommodityWisePurchase />}
                    />
                    <Route
                      path="/product-wise-purchase"
                      element={<ProductWisePurchase />}
                    />
                    <Route
                      path="/dealer-wise-purchase"
                      element={<DealerWisePurchase />}
                    />
                    <Route
                      path="/hsn-wise-purchase"
                      element={<HSNWisePurchase />}
                    />
                    <Route
                      path="/brand-wise-purchase"
                      element={<BrandWisePurchase />}
                    />
                    <Route
                      path="/tax-wise-purchase"
                      element={<TaxWisePurchase />}
                    />
                    {/**CRM */}
                    <Route
                      path="/today-birthdays"
                      element={<TodayBirthDays />}
                    />
                    <Route
                      path="/today-anniversaries"
                      element={<TodayAnniversaries />}
                    />
                    <Route path="/total-dues" element={<TotalDues />} />
                    {/**Graphs */}
                    <Route path="/graphs" element={<Graphs />}></Route>
                    {/**Bar code check */}
                    <Route
                      path="/bar-code-check"
                      element={<BarCodeCheck />}
                    ></Route>
                    <Route
                      path="/file-import"
                      element={<ExcelUploadPurchase />}
                    ></Route>
                    <Route
                      path="/mail-book-register"
                      element={<MailBookRegister />}
                    />
                    <Route path="/user-accounts" element={<UserAccounts />} />
                    <Route
                      path="/user-account-manager"
                      element={<UserAccountManager />}
                    />
                    <Route
                      path="/firm-configuration"
                      element={<FirmConfiguration />}
                    />
                    <Route path="/upload-image" element={<UploadImage />} />

                    <Route
                      path="/whatsapp-sms-templates"
                      element={<WhatsAppTemplates />}
                    />
                    <Route
                      path="/counter-config"
                      element={<CounterConfigMaster />}
                    />
                    {/** Masters */}
                    <Route path="/area-master" element={<AreaMaster />} />
                    <Route path="/state-master" element={<StateMaster />} />
                    <Route path="/purchase-type-master" element={<PurchaseTypeMaster />} />
                    <Route path="/brand-master" element={<BrandMaster />} />
                    <Route
                      path="/item-category"
                      element={<ItemCategoryMaster />}
                    />
                    <Route path="/item-master" element={<ItemMaster />} />
                    <Route path="/size-master" element={<SizeMaster />} />
                    <Route path="/colour-master" element={<ColourMaster />} />
                    <Route path="/fitting-master" element={<FittingMaster />} />
                    <Route path="/sleeves-master" element={<SleevesMaster />} />
                    <Route path="/code-master" element={<CodeMaster />} />
                  </Routes>
                </DashboardLayout>
              ) : (
                ""
              )
            }
          ></Route>
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
